import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const ContactUSDetails = (props) => {
  const [response, set_response] = useState("");

  let history = useHistory();

  const [
    get_contactus_details_error,
    get_contactus_details_loading,
    get_contactus_details_data,
    get_contactus_details_function,
  ] = useRequest({
    method: "post",
    url: "/get_contactus_details",
    body: {
      contactus_id: props.match.params.id,
    },
  });

  const [
    add_response_contactus_error,
    add_response_contactus_loading,
    add_response_contactus_data,
    add_response_contactus_function,
  ] = useRequest({
    method: "post",
    url: "/add_response_contactus",
    body: {
      contactus_id: props.match.params.id,
      response,
    },
    isFunction: true,
  });

  return !get_contactus_details_data ? null : (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جزییات تماس با ما</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">جزییات تماس با ما</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                نام : {get_contactus_details_data.data.name}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                تلفن همراه :{" "}
                                {get_contactus_details_data.data.phone_number}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                ایمیل: {get_contactus_details_data.data.email}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                متن : {get_contactus_details_data.data.text}
                              </div>
                              {get_contactus_details_data.data.response ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    وضعیت : پاسخ داده شده
                                  </div>
                                  <div>
                                    متن پاسخ داده شده :{" "}
                                    {get_contactus_details_data.data.response}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <div class="row">
                                    <div class="col-12">
                                      <h6>پاسخ :</h6>
                                      <div class="card-content">
                                        <div class="row">
                                          <div class="col-12">
                                            <fieldset class="form-group">
                                              <textarea
                                                id="_little_des"
                                                class="form-control"
                                                // id="basicTextarea"
                                                rows="3"
                                                placeholder="متن پاسخ"
                                                value={response}
                                                onChange={(e) =>
                                                  set_response(e.target.value)
                                                }
                                                // value={little_des}
                                                // onChange={(e) => setLittleDes(e.target.value)}
                                              ></textarea>
                                            </fieldset>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <button
                                    onClick={() => {
                                      var $white = "#fff";
                                      $.blockUI({
                                        message:
                                          '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                                        // timeout: 2000, //unblock after 2 seconds
                                        overlayCSS: {
                                          backgroundColor: $white,
                                          opacity: 0.8,
                                          cursor: "wait",
                                        },
                                        css: {
                                          border: 0,
                                          padding: 0,
                                          backgroundColor: "transparent",
                                        },
                                      });
                                      add_response_contactus_function()
                                        .then(() => {
                                          history.goBack();
                                          $.unblockUI();
                                        })
                                        .catch(() => {
                                          utils.showAlert(
                                            "خطایی به وجود آمده است",
                                            "error"
                                          );
                                          $.unblockUI();
                                        });
                                    }}
                                    style={{
                                      width: "fit-content",
                                    }}
                                    type="button"
                                    class="btn btn-success mr-1 mb-1 "
                                  >
                                    ارسال پاسخ
                                  </button>{" "}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { ContactUSDetails };
